<template>
  <Layout :footer-style="1">
    <div class="rn-blog-details-area">
      <div class="post-page-banner rn-section-gapTop">
        <div class="container">
          <div class="row">
            <div class="col-lg-8 offset-lg-2">
              <div class="content text-center">
                <div class="page-title">
                  <h1 class="theme-gradient">
                    Imprint
                  </h1>
                </div>
                <ul class="rn-meta-list">
                  <li>
                    <Icon name="user" class="size-20"/>
                    <router-link to="#">Octomated GmbH</router-link>
                  </li>
                  <li>
                    <Icon name="calendar" class="size-20"/>
                    18. October 2022
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-details-content pt--60 rn-section-gapBottom">
        <div class="container">
          <div class="row">
            <div class="col-lg-8 offset-lg-2">
              <div class="content">
                <h4 class="mt-0">Combined site notice (identification of provider)</h4>
                <p>Provider and thus responsible for the business and commercial online offer is
                  Octomated GmbH, represented by the Managing Directors Eugen Heinrich and Philipp Wegner.
                  <br>
                  Information according to Article 2 Paragraph 1 Service Information Duty Ordinance (DL-InfoV).
                  <br>
                  This online offer is an information offer from
                </p>
                <p>
                  Octomated GmbH<br>
                  Pfarrgasse 3<br>
                  D-82266 Inning am Ammersee<br>
                  Germany
                </p>

                <h4 class="mt-0">Contact</h4>
                <p>
                  Telephone: +49 8143 990370-0<br>
                  E-Mail: info@octomated.com<br>
                  Internet: https://www.octomated.com
                </p>

                <h4 class="mt-0">Headquarters</h4>
                <p>D-82266 Inning am Ammersee, Germany</p>

                <h4 class="mt-0">Jurisdiction</h4>
                <p>Municipal Court Munich, HRB 271727</p>

                <h4 class="mt-0">Legal form of company</h4>
                <p>Company with limited liability (GmbH)</p>

                <h4 class="mt-0">Applicable law</h4>
                <p>Law of the Federal Republic of Germany (BRD)</p>

                <h4 class="mt-0">Tax office</h4>
                <p>Tax office Starnberg<br>VAT Identification Number: DE350248416</p>

                <h4 class="mt-0">Managing Directors authorized to act as representative</h4>
                <p>Eugen Heinrich<br>Philipp Wegner</p>

                <h4 class="mt-0">Trade Office</h4>
                <p>
                  Strandbadstr. 2<br>
                  82319 Starnberg<br>
                  Tel: +49 8151148468<br>
                  Fax: +49 815114811468<br>
                  E-Mail: info@LRA-starnberg.de
                </p>

                <h4 class="mt-0">Chamber of Industry and Commerce</h4>
                <p>
                  Industrie- und Handelskammer für München und Oberbayern<br>
                  Körperschaft des öffentlichen Rechts<br>
                  Max-Joseph-Straße 2<br>
                  80333 München<br>
                  Tel: +49 89 5116-0<br>
                  Fax: +49 89 5116-1306<br>
                  E-Mail: info@muenchen.ihk.de
                </p>

                <h4 class="mt-0">Pecuniary loss liability insurance</h4>
                <p>HISCOX Europe Underwriting Ltd.<br>
                  Arnulfstraße 31, D-80636 München
                </p>

                <h4 class="mt-0">Area of application</h4>
                <p>IT and telecommunications companies</p>

                <h4 class="mt-0">Information on online dispute resolution according to art. 14/1 ODR-VO</h4>
                <p>The EU commission provides a platform for online dispute resolution (OS) that can be accessed at <a
                  href="https://ec.europa.eu/consumers/odr">https://ec.europa.eu/consumers/odr</a>.The OS platform
                  serves as a contact point for out-of-court settlement of disputes concerning contractual obligations
                  arising from online purchase contracts.<br><br>

                  We are neither obliged nor prepared to participate in a dispute settlement procedure with a consumer
                  arbitration service.</p>


                <h4 class="mt-0">Responsible for journalistic and editorial contributions, pursuant to Article 18 Paragraph 2
                  Medienstaatsvertrag</h4>
                <p>(previousely in Article 55 Paragraph 2 Interstate Broadcasting Treaty (RStV))
                  <br>
                  Eugen Heinrich<br>
                  Octomated GmbH<br>
                  Pfarrgasse 3, D-82266 Inning am Ammersee</p>

                <h4 class="mt-0">Technical support of this online offer</h4>
                <p>
                  Octomated GmbH<br>
                  Pfarrgasse 3<br>
                  D-82266 Inning am Ammersee<br>
                  Telephone: +49 8143 990370-0<br>
                  E-Mail: info@octomated.com
                </p>

                <h4 class="mt-0">Object of the company of Octomated GmbH</h4>
                <p>Development and sales of software, SaaS and maintenance as well as the establishment and maintenance
                  of the infrastructure.</p>

                <h4 class="mt-0">Legal disclaimer</h4>
                <h5 class="mt-0">Liability for contents</h5>
                <p>The contents of our pages were created with the utmost care. However, we cannot guarantee the
                  accuracy, completeness and timeliness of the content. As a service provider, we are responsible for
                  our own content on these pages under the general laws according to Article 7 Paragraph 1 TMG. According to Article 8
                  to Article 10 TMG, however, we are not obligated as a service provider to monitor transmitted or stored
                  third-party information or to investigate circumstances that indicate illegal activity. Obligations to
                  remove or block the use of information under the general laws remain unaffected. However, liability in
                  this regard is only possible from the point in time at which a concrete infringement of the law
                  becomes known. If we become aware of such infringements, we will remove this content immediately.
                </p>
                <h5 class="mt-0">Liability for links</h5>
                <p>Our offer contains links to external websites of third parties, on whose contents we have no
                  influence. Therefore, we cannot assume any liability for these external contents. The respective
                  provider or operator of the pages is always responsible for the content of the linked pages. The
                  linked pages were checked for possible legal violations at the time of linking. Illegal contents were
                  not recognizable at the time of linking. However, a permanent control of the contents of the linked
                  pages is not reasonable without concrete evidence of a violation of the law. If we become aware of any
                  infringements, we will remove such links immediately.
                </p>

                <h4 class="mt-0">Trademark protection</h4>
                <p>Each trademark or logo mentioned here is the property of the respective company. Trademarks and names
                  are mentioned here purely for informational purposes.</p>

                <h4 class="mt-0">Copyright</h4>
                <p>All rights reserved. Text, images, and graphics, as well as their arrangement on the website are
                  subject to copyright and other intellectual property protection. The content of this website may not
                  be copied, published, changed or made available to Third Parties for commercial use.</p>

                <h4 class="mt-0">Note: General Equal Treatment Act (AGG)</h4>
                <p>For reasons of easier legibility, gender-specific differentiation is not used. The same terms apply
                  to both genders in the sense of equal treatment.</p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '../components/common/Layout'
import Breadcrumb from '../components/elements/breadcrumb/Breadcrumb'
import Icon from '../components/icon/Icon'

export default {
  name: 'Imprint',
  components: {Icon, Layout, Breadcrumb},
  metaInfo() {
    return {
      title: this.$t('imprint.meta.title'),
      htmlAttrs: {
        lang: 'de',
      },
      meta: [
        {name: 'description', content: this.$t('imprint.meta.description')},
        {name: 'og:title', content: this.$t('imprint.meta.title')},
        {name: 'og:description', content: this.$t('imprint.meta.description')},
        {name: 'og:locale', content: this.$route.params.locale},
        {name: 'twitter:title', content: this.$t('imprint.meta.title')},
        {name: 'twitter:description', content: this.$t('imprint.meta.description')},
      ],
    }
  },
}
</script>
